import { render, staticRenderFns } from "./TaxonomyArticle.vue?vue&type=template&id=1873c83b&"
import script from "./TaxonomyArticle.vue?vue&type=script&lang=js&"
export * from "./TaxonomyArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports